import styled from 'styled-components';

export const StyledCreditCardPage = styled.div`
    display: flex;
    gap: 130px;
    font-family: var(--bllink-font-headers);

    .credit-card-and-actions-block.credit-card-page-block {
        padding: 47px 70px;
        max-width: 570px;
        font-family: var(--bllink-font-primary);
      
        .payment-amount{
          font-size: 130%;          
          text-align: center;
          margin-bottom: 22px;
          .currency-value {
            font-weight: bold;
          }
        }

        form {
            grid-template-columns: 1fr;
            grid-template-rows: repeat(3, 1fr);
            row-gap: 18px;

            
    
            .details-wrapper {
                display: flex;
                gap: 60px;
                align-items: end;
                
                .date {
                  direction: ltr;
                    align-items: end;
                    display: flex;
                    align-items: end;
                    gap: 20px;

                    .bllink-input-border {
                        text-align: center;
                    }

                    .separator {
                        color: rgba(55, 54, 71, 0.5);
                        font-size: 20px;
                        margin-bottom: 10px;
                        font-weight: 700;
                    }
                }

                .cvv-wrapper {
                    position: relative;

                    .dots {
                        display: grid;
                        grid-template-rows: repeat(3, 1fr);
                        grid-template-columns: repeat(3, 1fr);
                        position: absolute;
                        gap: 2px;
                        left: ${({ ltr }) => ltr ? '' : '15px'};
                        right: ${({ ltr }) => ltr ? '15px' : ''};
                        bottom: 15px;

                        .dot {
                            background: rgba(55, 54, 71, 0.5);
                            width: 5px;
                            height: 5px;
                        }
                    }
                }
            }

            .btn-wrapper {
                width: 100%;
                margin-top: 40px;
                display: flex;
                justify-content: center;

                .app-btn {
                    width: 300px;
                }
            }
        }
    }

    .payment-services {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        margin-top: 60px;

        .header {
            font-size: 22px;
            color: rgba(55, 54, 71, 0.7);
        }

        .images {
            display: flex;
            gap: 12px;

            .img-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 78px;
                height: 44px;
                background: #FFFFFF;
                border-radius: 3px;
            }
        }
    }

    .credit-card {
        width: 370px;
        height: 213px;
        background: linear-gradient(120deg, rgba(227,227,227,1) 0%, rgba(232,232,232,1) 50%, rgba(255,255,255,1) 100%);
        border-radius: 10px;
        filter: drop-shadow(0px 20px 40px rgba(67, 57, 126, 0.1));
        border: 2px solid rgba(220, 219, 255, 0.5);
        padding: 35px 30px;
        color: #253A53;
        direction: ltr;

        .top-row, .middle-row, .bottom-row {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .logo {
                max-width: 70px;
                max-height: 35px;
            }
        }

        .middle-row {
            margin-top: 33px;
            align-items: flex-end;

            .chip {
                margin-bottom: 10px;
            }
        }

        .bottom-row {
            margin-top: 8px;
            font-family: var(--bllink-font-primary);
            font-weight: 700;

            .card-digits {
                display: flex;
                gap: 14px;
                font-size: 18px;
            }
        }
    }

    @media screen and (max-width: 768px) {
        max-width: 90%;
        margin: auto;
        position: relative;

        .credit-card-block-wrapper {
            width: 100%;

            .credit-card-and-actions-block.credit-card-page-block {
                width: 100%;
                padding: 160px 22px 70px;

                form {
                    display: flex;
                    flex-direction: column;

                    label {
                        width: 100%;
                        text-align: start;
                    }

                    .details-wrapper {
                        flex-direction: column;
                        align-items: start;
                        gap: 20px;

                        .cvv-wrapper {
                            width: 160px;
                        }
                    }
                }

            }
        }

        .credit-card {
            position: absolute;
            width: 275px;
            height: 158px;
            top: -60px;
            left: 50%;
            transform: translateX(-50%);
            padding: 20px 22px;
            font-size: 14px;
            z-index: 99;

            .middle-row {
                margin-top: 15px;
            }
        }
    }
`
